import _to_consumable_array from "@swc/helpers/src/_to_consumable_array.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { StarFill, StarHalfFill, StarNoFill } from "../assets";
import styles from "./star-rating.module.css";
export var StarRating = function(param) {
    var starRating = param.starRating;
    var stars = _to_consumable_array(Array.from({
        length: 5
    }).keys());
    var starComponents = stars.map(function(_, index) {
        var starNumber = index + 1;
        var idPrefix = "star-".concat(starRating, "-").concat(starNumber);
        var isFilled = starNumber <= Math.floor(starRating / 2);
        var isHalf = starNumber === Math.ceil(starRating / 2) && starRating % 2 !== 0;
        return isFilled ? /*#__PURE__*/ _jsx(StarFill, {}, starNumber) : isHalf ? /*#__PURE__*/ _jsx(StarHalfFill, {
            idPrefix: idPrefix
        }, starNumber) : /*#__PURE__*/ _jsx(StarNoFill, {}, starNumber);
    });
    return /*#__PURE__*/ _jsx("div", {
        className: styles.starRatingContainer,
        children: starComponents
    });
};
